const sheetSet = {
  state: {
    folderData: {},
    isMajor: {},
    selectionData: [],
    rowData: {}
  },

  mutations: {
    SET_FOLDERDATA (state, data) {
      state.folderData = data;
    },
    SET_ISMAJOR(state, data) {
      state.isMajor = data;
    },
    SET_SELECTIONDATA(state, data) {
      state.selectionData = data;
    },
    SET_ROWDATA(state, data) {
      state.rowData = data;
    }
  },

  actions: {
    setFolderData ({ commit }, data) {
      commit('SET_FOLDERDATA', data);
    },
    setIsMajor({ commit }, data) {
      commit('SET_ISMAJOR', data);
    },
    setSelectionData({ commit }, data) {
      commit('SET_SELECTIONDATA', data);
    },
    setrowData({ commit }, data) {
      commit('SET_ROWDATA', data);
    }
  }
};

export default sheetSet;
